import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import LinkIcon from '@material-ui/icons/Link';
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { NavLink } from "react-router-dom";

import './NestedList.css'

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 400,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
	navlink : {
		textDecoration: 'none'
	},
	listitem: {
		'& .MuiListItemText-primary': {
			fontWeight: 'bold'
		}
	}
}));

const SimpleList = ({itemName, linkLocation}) => {
	//console.log(linkLocation)
	const classes = useStyles()
	return(
	<NavLink to={linkLocation} style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold', fontFamily: 'Roboto' }} exact className="activeClass" activeStyle={{
    fontWeight: "bold",
    color: "blue",
		textDecoration: 'none'
  }} >
		<ListItem button  >
				<ListItemText primary={itemName} className={classes.listitem} />
		</ListItem>
	</NavLink>	
	)	
}

const SimpleListNoLink = ({itemName}) => {
	//console.log(linkLocation)
	const classes = useStyles()
	return(
		<ListItem button>
				<ListItemText primary={itemName} className={classes.listitem} />
		</ListItem>	
	)	
}


const NestedList = ({itemName, Children, linkLocation}) => {
  const [open, setOpen] = React.useState(false);
	const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
  };

	const ExpandIcon = ({isOpen, onClick}) => {
		return isOpen ? <ExpandLess onClick={onClick} /> : <ExpandMore onClick={onClick}/>
	}

  return (
    <>
			{/* <NavLink to={linkLocation}> */}
				<ListItem button onClick={handleClick}>
					<ListItemText primary={itemName} className={classes.listitem}  />
					<ExpandIcon isOpen={open} onClick={handleClick} />
				</ListItem>

				<Collapse in={open} timeout="auto" unmountOnExit className={classes.nested}>
					<List component="div" disablePadding>
						
						<Children />

					</List>
				</Collapse>
			{/* </NavLink> */}
    </>
  );
}

export {NestedList, SimpleList, SimpleListNoLink};